"use strict";

angular.module("core")

.config(function(FlashProvider) {
    FlashProvider.setTemplatePreset("transclude");
})

.factory("FlashBag", function(
    $q, $rootScope, $location, $anchorScroll, $window, $interval, Flash, gettext, gettextCatalog
) {
    var routeChangeMessages = [];
    var displayedMessages = [];
    var DEFAULT_SUCCESS_MESSAGE_LIFE = 7000;

    $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
        dismissDisplayedMessages();
        displayedMessages = routeChangeMessages;
        routeChangeMessages = [];
    });

    var i18n = {
        "sorry": function() {
            return gettextCatalog.getString("Sorry, something went wrong.")
        },
        "login_failed": function() {
            return gettextCatalog.getString("Login failed, please try again.")
        },
        "email_success": function() {
            return gettextCatalog.getString("You have successfully sent the order to that email:")
        },
        "email_failure": function() {
            return gettextCatalog.getString("The email has not been sent.")
        }
    };

    function executeDismiss(messageDuration, messageId) {
        if (messageDuration) {
            $interval(function() {
                Flash.dismiss(messageId);
            }, messageDuration, 1);
        }
        else {
            Flash.dismiss(messageId);
        }
    }

    function dismissDisplayedMessages() {
        for (var i = 0; i < displayedMessages.length; i++) {
            var messageId = displayedMessages[i]["messageId"];
            var messageDuration = displayedMessages[i]["messageDuration"];
            executeDismiss(messageDuration, messageId);
        }
        displayedMessages = [];
    }

    function createMessage(type, message, title, surviveNextRouteChange, messageDuration, keepOtherMessage) {
        if (!keepOtherMessage) keepOtherMessage = false;
        if (!messageDuration) messageDuration = 0;

        var fullMessage = title ? "<strong>" + title + "</strong><br />" + message : message;
        var messageId = Flash.create(type, fullMessage, 0, {container: "global-flash"}, true);

        if (messageDuration) {
            $interval(function() {
                Flash.dismiss(messageId);
            }, messageDuration, 1);
        }

        if (surviveNextRouteChange) {
            routeChangeMessages.push({messageId: messageId, messageDuration: messageDuration});
        }
        else {
            if (!keepOtherMessage) {
                dismissDisplayedMessages();
            }
            displayedMessages.push({messageId: messageId});
        }

        // Scroll up the page when a flash bag is created
        $window.scrollTo(0, 0);
        $anchorScroll();

        return messageId;
    }

    function createErrorMessage(response, surviveNextRouteChange) {
        var message = formatErrorResponse(response);
        return createMessage("danger", message || i18n.sorry(), null, surviveNextRouteChange);
    }

    function formatErrorResponse(response) {
        var message = "";
        if (response && typeof response.data == "object" && response.data != null) {
            angular.forEach(response.data, function(value, key) {
                if (typeof value == "object" && key !== "api_response_flags") {
                    angular.forEach(value, function(error) {
                        if (typeof error == "object") {
                            for(key in error) {
                                message += key + ': ' + error[key] + "<br/>";
                            }
                        }
                        else {
                            message += error + "<br/>";
                        }
                    });
                }
                else if (typeof value != "object") {
                    message += value + "<br/>";
                }
            });
        }
        return message;
    }

    function formatErrorList(errors) {
        var message = "<ul>";
        angular.forEach(errors, function(error) {
            message += "<li>" + error + "</li>";
        });
        message += "</ul>";
        return message;
    }

    return {
        success: function(message, surviveNextRouteChange, messageDuration, keepOtherMessage) {
            if (message)
                return createMessage("success", message, null, surviveNextRouteChange, messageDuration === undefined ? DEFAULT_SUCCESS_MESSAGE_LIFE : messageDuration, keepOtherMessage);
        },
        warning: function(message, surviveNextRouteChange, messageDuration, keepOtherMessage) {
            if (message)
                return createMessage("warning", message, null, surviveNextRouteChange, messageDuration === undefined ? DEFAULT_SUCCESS_MESSAGE_LIFE : messageDuration, keepOtherMessage);
        },
        error: function(error, surviveNextRouteChange, messageDuration, keepOtherMessage) {
            if (error)
                return createMessage("danger", error, null, surviveNextRouteChange, messageDuration === undefined ? null : messageDuration, keepOtherMessage);
        },
        info: function(message, surviveNextRouteChange) {
            if (message)
                return createMessage("info", message, null, surviveNextRouteChange);
        },
        alertWithContainer: function(type, container, message) {
            var messageId = Flash.create(type, message || i18n.sorry(), 0, {container: container});
            $interval(function() {
                Flash.dismiss(messageId);
            }, DEFAULT_SUCCESS_MESSAGE_LIFE, 1);
        },
        apiError: function(response, surviveNextRouteChange) {
            return createErrorMessage(response, surviveNextRouteChange);
        },
        responseErrorInterceptor: function(response) {
            createErrorMessage(response);
            return $q.reject(response);
        },
        loginError: function(response) {
            var type, message;
            if (response.status == 404) {
                type = "warning";
                message = i18n.login_failed();
            }
            else {
                return createErrorMessage(response);
            }
            return createMessage(type, message, i18n.sorry());
        },
        preformattedWarning: function(message, title, surviveNextRouteChange, keepOtherMessage) {
            if (title == null) {
                title = i18n.sorry();
            }
            if (message)
                return createMessage("warning", message, title, surviveNextRouteChange, null, keepOtherMessage);
        },
        preformattedError: function(message, surviveNextRouteChange) {
            if (message)
                return createMessage("danger", message, i18n.sorry(), surviveNextRouteChange);
        },
        emailResult: function(address) {
            if (address)
                this.success(i18n.email_success() + " " + address);
            else
                this.preformattedError(i18n.email_failure());
        },
        dismiss: function(messageId) {
            Flash.dismiss(messageId);
        },
        clearAll: function() {
            Flash.clear();
        },
        messages: i18n,
        setSuccessMessageLifetime: function(milliseconds) {
            if (milliseconds)
                DEFAULT_SUCCESS_MESSAGE_LIFE = milliseconds;
        },
        getSuccessMessageLifetime: function() {
            return DEFAULT_SUCCESS_MESSAGE_LIFE;
        },
        formatErrorList: formatErrorList,
        formatErrorResponse: formatErrorResponse
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/flash-bag/flash-bag.factory.js
// module id = 461
// module chunks = 0